module.exports = __webpack_public_path__ + "img/jerk_sandwich_pork.ad799571.jpg";